import Analytics from '@web/services/Analytics/Analytics'

export function postCancelScreenView (subscriptionId: number): void {
  const key = `post_cancel_screen_view_${subscriptionId}`
  if (sessionStorage.getItem(key)) return
  sessionStorage.setItem(key, '1')

  Analytics.send({
    action: 'post_cancel_screen_view',
    subscription_id: String(subscriptionId)
  })
}

export function postCancelShareExperienceClick (subscriptionId: number): void {
  Analytics.send({
    action: 'post_cancel_share_experience_click',
    subscription_id: String(subscriptionId),
    cta_name: 'share_experience'
  })
}

export function postCancelContinueClick (subscriptionId: number): void {
  Analytics.send({
    action: 'post_cancel_continue_click',
    subscription_id: String(subscriptionId),
    cta_name: 'continue'
  })
}
